import React from 'react';
import { Text } from '@fluentui/react';
import IvicosStrings from 'kits/language/stringKit';

const ArtGalleryInfo: React.FC<{ type: string; content: any }> = ({ type, content }) => {
    if (type !== 'art-gallery') return null;
    const { title, artist, medium, date } = content || {};
    if (!title && !artist && !medium && !date) return null;

    return (
        <>
            {title && (
                <Text variant="xLarge" style={{ fontWeight: 'bold', marginBottom: 10 }}>
                    {title}
                </Text>
            )}
            {artist && <Text variant="medium">{IvicosStrings.personalMeetingCornerStrings.artGallery.artist.replace('{artist}', artist)}</Text>}
            {medium && <Text variant="medium">{IvicosStrings.personalMeetingCornerStrings.artGallery.medium.replace('{medium}', medium)}</Text>}
            {date && <Text variant="medium">{IvicosStrings.personalMeetingCornerStrings.artGallery.date.replace('{date}', date)}</Text>}
        </>
    );
};

export default ArtGalleryInfo;
